import React, {
    createContext,
    useState,
    useContext,
    ReactNode,
    useEffect,
    Dispatch,
    SetStateAction,
    useLayoutEffect,
} from "react";
import Favicon from "../assets/favicon-128x128.png";
import { Context } from "..";
import { useNavigate, useLocation } from "react-router-dom";
import { IFunctionPermissions } from "../common/api_interfaces/role/IFunctionPermissions";
import FunctionSystem from "../models/functionCode/functionsSystem"; 
import { FunctionsAccessRequest } from "../common/api_interfaces/role/FunctionsAccessRequest";
// import FunctionSystem from "../models/functionCode/functionsSystem"; 

interface IUserContext {
    systemUserAccess: IFunctionPermissions[];
    checkUserReg: () => void;
    regPersonCheck: boolean;
    setRegPersonCheck: Dispatch<SetStateAction<boolean>>;
    iconGetNew: any;
    setIconGetNew: Dispatch<SetStateAction<any>>;
    pageTitle: string;
    setPageTitle: Dispatch<SetStateAction<string>>;
}

const UserContext = createContext<IUserContext | undefined>(undefined);

export const useUserContext = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUserContext must be used within a UserProvider");
    }
    return context;
};

interface UserProviderProps {
    children: ReactNode;
}

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const location = useLocation();
    const [iconGetNew, setIconGetNew] = useState<any>(); //TODO переместить в UiContext
    const [pageTitle, setPageTitle] = React.useState<string>("Task Tracker"); //TODO переместить в UIContext
    const [systemUserAccess, setSystemUserAccess] = useState<IFunctionPermissions[]>([]);
    const [regPersonCheck, setRegPersonCheck] = useState<boolean>(true);

    useLayoutEffect(() => {
        (async () => {
            let pageTitleCurent = "Task Tracker";

            try {
                document.title = "Task Tracker";
                let data = await store.getPublicSettings();
                let iconGet = await store.commonService.getSystemLogo();
                if (iconGet.data.length) {
                    setIconGetNew(iconGet.data);
                } else {
                    setIconGetNew(Favicon);
                }
                if (data?.length) {
                    data.forEach((xx) => {
                        if (xx.paramName === "name") {
                            pageTitleCurent = xx.value?.length ? xx.value : "Task Tracker";
                            setPageTitle(pageTitleCurent);
                        }
                    });
                }
            } catch (err) {
                console.error(err);
            }
        })();
    }, []);

    function checkUserReg() {
        (async () => {
            try {
                const match = /\/api\/activate\/([a-zA-Z0-9\-]+)/.exec(location.pathname);
                if (match) {
                    store.setLinkNewPerson(match[1]);
                    const newPerson = await store.getDataLinkPerson(store.linkNewPerson);

                    if (!newPerson) {
                        return;
                    }

                    store.setUserWithStatus(newPerson);
                    const success: boolean | undefined = await store.logout();

                    if (!success) {
                        console.error("Logout failed");
                    }

                    if (newPerson.status === "Приглашен") {
                        navigate("/register");
                    } else if (newPerson.status === "Ждет активацию") {
                        navigate("/login");
                    }
                }
                setRegPersonCheck(false);
            } catch (err) {
                console.log(err);
            }
        })();
    }

    useEffect(() => {
        if (location.pathname.includes("/api/activate")) {
            checkUserReg();
        }
    }, [location.pathname]);

    useEffect(() => {
        (async () => {
            const newCheckRole: FunctionsAccessRequest = {
                projectId: null,
                boardId: null,
                functionCodes: new FunctionSystem().getAppFunction,
            };

            const checkThisRole = await store.hasPermission(newCheckRole);
            setSystemUserAccess(checkThisRole);
        })();
    }, [store.isAuth]);

    const value: IUserContext = {
        systemUserAccess,
        checkUserReg,
        regPersonCheck,
        setRegPersonCheck,
        iconGetNew,
        setIconGetNew,
        pageTitle,
        setPageTitle,
    };

    return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
